module.exports = __webpack_public_path__ + "img/1557614077425033218.84b9e76b.png";